import { RequestRPC } from '../http/request.rpc';

export class RpcError {
  public message: string;
  public msg: string;
  public detailMessage: string;
  public permissionDeniedType: string;
  public code: number;
  public type = 'RPC_ERROR';
  public originalCall: RequestRPC;

  constructor(errorObject: any, originalCall: any) {
    this.message =
      errorObject.message ||
      'Something went wrong. Please try again or contact Support.';
    this.msg = errorObject.msg;
    this.detailMessage = errorObject.detailMessage;
    this.permissionDeniedType = errorObject.permissionDeniedType;
    this.code = errorObject.code;
    this.originalCall = JSON.parse(originalCall);
  }
}
